import { cn } from "@shared-utils/ui";
import React from "react";
import "@shared-styles/loader-ellipsis.css";

interface LoaderEllipsisProps {
  className?: string;
  colorClass?: string;
}

export const LoaderEllipsis = ({ className }: LoaderEllipsisProps) => {
  return (
    <div
      className={cn(
        "*:pg-primary flex justify-center space-x-3 text-center *:h-2 *:w-2 *:rounded-full",
        className,
      )}
    >
      <div className="animate-[loader-ellipsis_1.4s_0.0s_infinite_ease-in-out_both]"></div>
      <div className="animate-[loader-ellipsis_1.4s_0.2s_infinite_ease-in-out_both]"></div>
      <div className="animate-[loader-ellipsis_1.4s_0.4s_infinite_ease-in-out_both]"></div>
    </div>
  );
};
